import { vaultPostRequest } from '../helpers';
import type { IDeleteImgRequest } from './delete-img-request';
import { deleteImgResponseSchema, type IDeleteImgResponse } from './delete-img-response';

export async function deleteImgApi(body: IDeleteImgRequest): Promise<IDeleteImgResponse> {
  return vaultPostRequest({ path: '/img/delete', body, schema: deleteImgResponseSchema });
}
